import React, {Component} from 'react'
import {API_ROOT} from '../../../baseUrls'
import { withStyles } from "@mui/styles";
import {connect} from 'react-redux'
import {markPasswordPresent} from '../../../state/actions/authActions';
import {Box, Button, TextField, Typography,} from '@mui/material';
import Alert from '@mui/material/Alert'

const styles = () => ({
  fieldWrapper: {
    marginBottom: 16,
  },
  buttonWrapper: {
    marginTop: 24,
  }
})

class Password extends Component {
  constructor(props) {
    super(props)
    this.state = {
      passwordMode: 'display',
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      showPasswordSuccessMessage: false,
      showPasswordValidationErrors: false,
      passwordValidationMessage: '',
    }
  }

  updatePassword() {
    if (this.state.newPassword !== this.state.confirmNewPassword) {
      return this.setState({ showPasswordValidationErrors : true, passwordValidationMessage: "Passwords don't match." })
    }

    const formData = new FormData()
    formData.append("user[old_password]", this.state.oldPassword)
    formData.append("user[password]", this.state.newPassword)
    formData.append("user[password_confirmation]", this.state.confirmNewPassword)
    // formData.append("authenticity_token", this.props.user.authenticity_token)

    fetch(`${ API_ROOT }/users/${ this.props.user.uid }/update`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': this.props.user.authenticity_token},
    })
    .then(resp => (resp.json()))
    .then(data => {
      if (data.status === 'ok') {
        this.setState({
          passwordMode: 'display',
          showPasswordSuccessMessage: true,
          showPasswordValidationErrors : false,
          oldPassword: '',
          newPassword: '',
          confirmNewPassword: '',
        }, () => this.props.markPasswordPresent())
      }
      else if (data.status === 'error') {
        this.setState({
          showPasswordSuccessMessage: false,
          showPasswordValidationErrors : true,
          passwordValidationMessage: data.message })
      }
    })
    .catch(error => console.error(error))
  }

  renderPasswordDisplay() {
    return (
      <div>
        { this.state.showPasswordSuccessMessage ? <div style={{marginBottom: "1rem"}}><Alert onClose={ () => this.setState({ showPasswordSuccessMessage: false }) }>Password was updated.</Alert></div> : '' }
        <Box sx={{ display: { xs: 'block', md: 'none' } }} style={{paddingBottom:"0.35rem"}}><Typography>Password</Typography></Box>
        <div style={{display:"flex", gap:"0.5rem"}}>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}><Typography>Password</Typography></Box>
          <Box display="flex" flexGrow={1} justifyContent="center"><Typography>	•	•	•	•	•	•	•	•</Typography></Box>
          <Button variant="contained" color="primary" onClick={ () => this.setState({ passwordMode: 'form' }) }>Update</Button>
        </div>
      </div>
    )
  }

  renderPasswordForm(classes) {
    return (
      <Box>
        <Typography className={classes.cardTitle} variant="subtitle1" gutterBottom>
          Password
        </Typography>
        { this.state.showPasswordValidationErrors ? <Alert onClose={ () => this.setState({ showPasswordValidationErrors: false }) } severity="error">{ this.state.passwordValidationMessage }</Alert> : '' }
        { this.props.user.has_password
          ? <Box className={ classes.fieldWrapper }>
              <TextField
                label="Old password"
                value={ this.state.oldPassword }
                type="password"
                margin="dense"
                size="small"
                fullWidth
                onChange={ evt => this.setState({ oldPassword: evt.target.value }) }
              />
            </Box>
          : null }
        <Box className={ classes.fieldWrapper }>
          <TextField
            label="New password"
            value={ this.state.newPassword }
            type="password"
            margin="dense"
            size="small"
            fullWidth
            onChange={ evt => this.setState({ newPassword: evt.target.value }) }
          />
        </Box>
        <Box className={ classes.fieldWrapper }>
          <TextField
            label="Confirm new password"
            value={ this.state.confirmNewPassword }
            type="password"
            margin="dense"
            size="small"
            fullWidth
            onChange={ evt => this.setState({ confirmNewPassword: evt.target.value }) }
          />
        </Box>
        <Box className={ classes.buttonWrapper }>
          <Button variant="contained" color="primary" onClick={ this.updatePassword.bind(this) }>Update</Button>
          <Button style={{ marginLeft: 8 }} variant="contained" color="primary" onClick={ () => this.setState({ passwordMode: 'display' }) }>Cancel</Button>
        </Box>
      </Box>
    )
  }

  render() {
    const { classes } = this.props
    return (this.state.passwordMode === 'display') ? this.renderPasswordDisplay(classes) : this.renderPasswordForm(classes)
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.auth,
    mindfile: state.mindfile,
  }
}

const mapDispatchToProps = {
  markPasswordPresent,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Password))
